module.exports = __webpack_public_path__ + "img/logo_inner.a9ff6032.png";